import { brand } from '../../brand';

export function Wordmark({ tone, title = brand.name }: { tone: 'dark' | 'light'; title?: string }) {
  return <PeerWordmark tone={tone} title={title} />;
}

/** MCPeer.ai: two nodes joined by one line (the agent and the app), then the name in the display face. */
function PeerWordmark({ tone, title }: { tone: 'dark' | 'light'; title: string }) {
  const ink = tone === 'dark' ? '#fff' : 'var(--mcper-ink)';
  return (
    <span className={`mcper-wordmark mcper-wordmark-text ${tone}`} role="img" aria-label={title} style={{ color: ink }}>
      <svg width="34" height="20" viewBox="0 0 34 20" aria-hidden="true" style={{ display: 'block' }}>
        <circle cx="7" cy="10" r="6" style={{ fill: 'var(--mcper-accent-bright)' }} />
        <rect x="12" y="9" width="10" height="2" style={{ fill: 'var(--mcper-accent-bright)' }} />
        <circle cx="27" cy="10" r="5" style={{ fill: 'none', stroke: 'var(--mcper-accent-bright)', strokeWidth: 2 }} />
      </svg>
      <span>
        MCPeer<span style={{ opacity: 0.55 }}>.ai</span>
      </span>
    </span>
  );
}
